
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/institutions/europe",
      function () {
        return require("private-next-pages/docs/institutions/europe.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/institutions/europe"])
      });
    }
  